var heading_default = {
  "fontElementMap": "hzbsW",
  "elementSpacing": "_84yKH",
  "headerOne": "EO0tC _84yKH",
  "headerTwo": "DEpv3 _84yKH",
  "headerThree": "tdem5 _84yKH",
  "headerFour": "xdN9R _84yKH",
  "headerFive": "_9Q0Dg _84yKH",
  "headerSix": "D0uEM _84yKH",
  "child": "_9-L3b"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
